export default "__VITE_ASSET__CCFS4tch__"